import { permitsPathSegment } from './landingDepartmentMerge';
/** Lowercase department keys that may appear in grid `DEPARTMENT` for the current URL segment. */
export function buildDepartmentKeyLcSet(urlDepartmentId, departmentsRaw) {
    const raw = urlDepartmentId.trim().toLowerCase();
    const keys = new Set();
    if (raw)
        keys.add(raw);
    for (const d of departmentsRaw) {
        const rid = (d.recordId ?? '').trim().toLowerCase();
        const seg = permitsPathSegment(d.href ?? '');
        if (!raw)
            continue;
        if (rid === raw || (seg && seg === raw)) {
            if (rid)
                keys.add(rid);
            if (seg)
                keys.add(seg);
        }
    }
    return keys;
}
export function filterPermitsCatalogForDepartment(catalog, urlDepartmentId, departmentsRaw) {
    if (!urlDepartmentId.trim() || !catalog.length)
        return [];
    const keyLc = buildDepartmentKeyLcSet(urlDepartmentId, departmentsRaw);
    return catalog.filter((p) => keyLc.has(p.departmentKey.trim().toLowerCase()));
}
export function groupCatalogByAgencyId(items) {
    const out = {};
    for (const p of items) {
        const aid = String(p.agencyKey ?? '').trim();
        if (!aid)
            continue;
        if (!out[aid])
            out[aid] = [];
        out[aid].push(p);
    }
    return out;
}
export function catalogItemToPermitListDto(p) {
    return {
        title: p.title,
        description: p.description,
        timeframe: p.processingTime,
        priceRange: p.applicationCost,
        scope: p.scope,
        applyNow: p.applyNow,
        recordId: p.recordId,
        detailsHref: p.detailsEmbedUrl,
    };
}
export function permitCountByAgencyFromCatalogItems(items) {
    const groups = groupCatalogByAgencyId(items);
    const counts = {};
    for (const [k, arr] of Object.entries(groups)) {
        counts[k] = arr.length;
    }
    return counts;
}
